/**
 * @deprecated Import from `@fluentui/react` package instead.
 */
export { Stack } from '@fluentui/react/lib/Stack';
